import {
  isTMTimePickerInputValue,
  TMTimePickerInputValue,
} from "src/ui/MTimePickerInput/timePickerUtils"
import { ErrorService } from "src/utils/ErrorService"

export function getInitialTime(
  initialDate?: Date | null
): TMTimePickerInputValue | null {
  if (!initialDate) {
    return null
  }

  const hours = initialDate.getHours().toString().padStart(2, "0")
  const minutes = initialDate.getMinutes().toString().padStart(2, "0")
  const time = `${hours}:${minutes}`

  if (!isTMTimePickerInputValue(time)) {
    ErrorService.captureMessage("Invalid time value", {
      context: { data: { initialDate, hours, minutes, time } },
    })
    return null
  }

  return time
}

/**
 * Converts a time picker input value to hours and minutes.
 *
 * @param time - The time picker input value to convert.
 * @returns The hours and minutes.
 */
export function timePickerInputValueToHoursAndMinutes(
  time: TMTimePickerInputValue
): { hours: number; minutes: number } {
  const [hours, minutes] = time.split(":")
  return { hours: Number(hours), minutes: Number(minutes) }
}
